/** Gestor de escritórios — só o super administrador da plataforma chega aqui (o menu nem mostra para os demais; a API recusa). */
import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '../lib/auth';
import { GestorEscritorios } from '../telas/plataforma/escritorios';

export const Route = createFileRoute('/_app/plataforma')({ component: Tela });

function Tela() {
  const { eu } = useAuth();
  if (!eu?.superAdmin) return (
    <>
      <div className="topbar"><div><h1>Escritórios</h1><div className="sub">plataforma</div></div></div>
      <div className="conteudo"><div className="alerta info">Esta área é do administrador da plataforma.</div></div>
    </>
  );
  return <GestorEscritorios />;
}
